import { lazy } from "react"
import { createBrowserRouter } from "react-router-dom"
import RootLayout from "../Layouts/Root/RootLayout"
import AdminLayout from "../Layouts/Admin/AdminLayout"

// Root Pages =======================================================================
const Home = lazy(() => import("../pages/root/Home/HomeIndex"))
const About = lazy(() => import("../pages/root/About/AboutIndex"))
const Contact = lazy(() => import("../pages/root/Contact/ContactIndex"))
const ProjrectDetails = lazy(() => import("../pages/root/Project/ProjectDetails"))
const SubProjectDetails = lazy(() => import("../pages/root/Project/SubProjectDetails"))
const AllProjects = lazy(() => import("../components/AllProject"))
const SellerOptions = lazy(() => import("../pages/root/SellerOptions"))
const CostomisedConstruction = lazy(() => import("../pages/root/CustomisedConstruction"))
const Events = lazy(() => import("../pages/root/Events/"))
const LoanFacility = lazy(() => import("../pages/root/LoanFacilities"))
const InsuranceFacility = lazy(() => import("../pages/root/InsuranceFacilities"))
const Gallery = lazy(() => import("../pages/root/Gallery"))
const Testimonials = lazy(() => import("../pages/root/Testimonials"))
const Feedback = lazy(() => import("../pages/root/Feedback"))


// Admin Pages ======================================================================
// Non Auth pages
const Login = lazy(() => import("../pages/admin/Auth/Login"))
// Authenicated Routes
const Dashboard = lazy(() => import("../pages/admin/Dashboard/DashboardIndex"))
const Projects = lazy(() => import("../pages/admin/Project/ProjectIndex"))
const SubProject = lazy(() => import("../pages/admin/Project/SubProject"))
const SubMenu = lazy(() => import("../pages/admin/Project/SubMenu"))
const Place = lazy(() => import("../pages/admin/Place/PlaceIndex"))
const Testimonial = lazy(() => import("../pages/admin/Testimonial/TestimonialIndex"))
const Setting = lazy(() => import("../pages/admin/Setting/SettingIndex"))
const Profile = lazy(() => import("../pages/admin/Profile/ProfileIndex"))
const AboutUs = lazy(() => import("../pages/admin/About/AboutIndex"))
const ContactUs = lazy(() => import("../pages/admin/Contact/ContactIndex"))
const SellerOption = lazy(() => import("../pages/admin/SellerOpttion"))
const CustomiseConstruction = lazy(() => import("../pages/admin/CustomiseConstruction"))
const InsuranceFacilities = lazy(() => import("../pages/admin/InsuranceFacility"))
const LoanFacilities = lazy(() => import("../pages/admin/LoanFacility"))
const FeedbackList = lazy(() => import("../pages/admin/Feedback"))
const Enquiry = lazy(() => import("../pages/admin/Enquiry"))



// sellerOption


const router = createBrowserRouter([
    // Root Routes ======================================================
    {
        path: "/", Component: RootLayout,
        children: [
            { path: "/", Component: Home },
            { path: "/about", Component: About },
            { path: "/contact", Component: Contact },
            { path: "/events", Component: Events },
            { path: "/seller-options", Component: SellerOptions },
            { path: "/customised-construction", Component: CostomisedConstruction },
            { path: "/insurance-facilities", Component: InsuranceFacility },
            { path: "/loan-facilities", Component: LoanFacility },
            { path: "/gallery", Component: Gallery },
            { path: "/testimonials", Component: Testimonials },
            { path: "/feedback", Component: Feedback },
            
            
            { path: "/project/:projectId", Component: ProjrectDetails },
            { path: "/place/:placeId", Component: SubProjectDetails },
            { path: "/all-projects", Component: AllProjects }
        ]
    },
    // Admin Routes =====================================================
    // Non-Authenticated Routes =========================================
    {
        path: "/auth",
        Component: "",
        children: [
            { path: "/auth/login", Component: Login },
        ]
    },
    // Athenticated Routes ==============================================
    {
        path: "/admin",
        Component: AdminLayout,
        children: [
            { path: "/admin/dashboard", Component: Dashboard },
            { path: "/admin/projects", Component: Projects },
            { path: "/admin/place", Component: Place },
            { path: "/admin/testimonial", Component: Testimonial },
            { path: "/admin/project/subproject", Component: SubProject },
            { path: "/admin/project/submenu", Component: SubMenu },
            { path: "/admin/setting", Component: Setting },
            { path: "/admin/profile", Component: Profile },
            { path: "/admin/about", Component: AboutUs },
            { path: "/admin/contact", Component: ContactUs },
            { path: "/admin/seller-option", Component: SellerOption },
            { path: "/admin/customised-construction", Component: CustomiseConstruction },
            { path: "/admin/insurance-facility", Component: InsuranceFacilities },
            { path: "/admin/loan-facility", Component: LoanFacilities },
            { path: "/admin/feedback", Component: FeedbackList },
            { path: "/admin/enquiry", Component: Enquiry },
             
            
            
        ]
    }
])

export default router;